import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  Audit,
  Page404,
  Main,
  Publishers,
  Profile,
  PublisherEdit,
  Report,
  ReportRequests,
  Advertisers,
  AdvertiserEdit,
  Sites,
  SitesAll,
  Campaigns,
  CampaignsAll,
  Users,
  UserEdit,
  SiteEdit,
  CampaignEdit,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
  NewPasswordPage,
  RegistrationComplete,
  UserInactive,
  Settings,
  Api,
  Finance,
  VerificationPage,
  ReportFeedRate,
  ReportClickRate,
  PaymentSuccessPage,
  PaymentFailPage,
  PaymentStatusPage,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'registration-complete', element: <RegistrationComplete /> },
            { path: 'verification', element: <VerificationPage /> },
            { path: 'user-inactive', element: <UserInactive /> },
          ],
        },
      ],
    },

    {
      path: 'payment',
      children: [
        { element: <PaymentStatusPage />, index: true },
        { path: 'success', element: <PaymentSuccessPage /> },
        { path: 'fail', element: <PaymentFailPage /> },
      ],
    },

    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'main',
          children: [
            { element: <Main />, index: true },
            { path: 'payment/:status', element: <Main /> },
          ],
        },
        {
          path: 'audit',
          children: [
            { element: <Audit />, index: true },
            { path: ':section', element: <Audit /> },
          ],
        },
        { path: 'sites/all', element: <SitesAll /> },
        {
          path: 'publishers',
          children: [
            { element: <Publishers />, index: true },
            { path: 'new', element: <PublisherEdit /> },
            { path: ':name/edit', element: <PublisherEdit /> },
            { path: ':pubParam', element: <Sites /> },
            { path: ':pubId/sites/:siteId/edit', element: <SiteEdit /> },
            { path: ':pubId/sites/new', element: <SiteEdit /> },
          ],
        },
        { path: 'campaigns/all', element: <CampaignsAll /> },
        {
          path: 'advertisers',
          children: [
            { element: <Advertisers />, index: true },
            { path: 'new', element: <AdvertiserEdit /> },
            { path: ':name/edit', element: <AdvertiserEdit /> },
            { path: ':advParam', element: <Campaigns /> },
            { path: ':advId/campaigns/:campaignId/edit', element: <CampaignEdit /> },
            { path: ':advId/campaigns/new', element: <CampaignEdit /> },
          ],
        },
        { path: 'report', element: <Report /> },
        { path: 'reportRequests', element: <ReportRequests /> },
        { path: 'reportFeedRate', element: <ReportFeedRate /> },
        { path: 'reportClickRate', element: <ReportClickRate /> },
        { path: 'profile', element: <Profile /> },
        {
          path: 'users',
          children: [
            { element: <Users />, index: true },
            { path: 'new', element: <UserEdit /> },
            { path: ':userId/edit', element: <UserEdit /> },
          ],
        },
        { path: 'settings', element: <Settings /> },
        { path: 'api', element: <Api /> },
        { path: 'finance', element: <Finance /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
